import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { routeTo } from "@/router/routeTo";

export function useSafeBackNavigation() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  return () => {
    const canGoBackInApp =
      window.history.length > 2 &&
      document.referrer.startsWith(window.location.origin);

    if (canGoBackInApp) {
      navigate(-1);
    } else {
      navigate(isAuthenticated ? routeTo.dashboard() : routeTo.root());
    }
  };
}